export const createGPXExport = (survey) => {
  let gpx = `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="OverSizeHub">
  <metadata>
    <name>${survey.name}</name>
    <time>${new Date().toISOString()}</time>
  </metadata>`;

  // Add POIs as waypoints
  survey.pois?.forEach(poi => {
    gpx += `
  <wpt lat="${poi.coordinates.latitude}" lon="${poi.coordinates.longitude}">
    <name>${poi.id}</name>
    <desc>${poi.notes || ''}</desc>
    <type>${poi.type}</type>
  </wpt>`;
  });

  // Add routes as tracks
  survey.routes?.forEach(route => {
    gpx += `
  <trk>
    <name>${route.name}</name>
    <trkseg>
      ${route.trackPoints.map(point => `
      <trkpt lat="${point.latitude}" lon="${point.longitude}">
        <time>${point.timestamp}</time>
      </trkpt>`).join('')}
    </trkseg>
  </trk>`;
  });

  gpx += '\n</gpx>';
  return gpx;
};